import { getNotifications, removeNotification } from '@vista-digital/occ-domain'
import { observe } from 'mobx'
import { useEffect } from 'react'
import { navigationService } from '@/content/services/navigation.service'

const useNotificationObserver = () => {
    useEffect(() => {
        const unobserve = observe(navigationService.pageObs, ({ newValue, oldValue }) => {
            /*
             * If a notification appears and you navigate to a new page before it dismounts, it will reappear again.
             * To fix this, we remove present notifications if the page changes. This will not run on page load.
             * */
            if (newValue !== oldValue) {
                const notifications = getNotifications()
                notifications.forEach(notification => {
                    removeNotification(notification.id)
                })
            }
        })

        return () => {
            unobserve()
        }
    }, [])
}

export default useNotificationObserver
